import { React } from 'react';
import { Flex, Image, Text } from '@chakra-ui/react';
import noInterviewsImage from '../../images/no-interviews.png';

function InterviewsError() {
  return (
    <Flex flexDirection='column' alignItems='center' maxWidth='715px' mx='auto' mt='100px' textAlign='center'>
      <Image src={noInterviewsImage} alt='No Interviews' />
      <Text fontSize='20px' fontWeight='700' mt='40px' mb='16px'>
        There was an error loading the interviews!
      </Text>
      <Text fontSize='20px' color='gray.600'>
        Unexpected Error
      </Text>
    </Flex>
  );
}

export default InterviewsError;
